import {wineAppAuthedClient} from './wineAppClient';

function getFavoriteLists(soldTo) {
  return wineAppAuthedClient.request({
    method: 'GET',
    url: `/favorite-lists/${soldTo}/`,
    responseType: 'json'
  }).then(response => response.data);
}

function getFavoriteList(soldTo, favoriteListId) {
  return wineAppAuthedClient.request({
    method: 'GET',
    url: `/favorite-lists/${soldTo}/${favoriteListId}/`,
    responseType: 'json'
  }).then(response => response.data);
}

function createFavoriteList(soldTo, name, description) {
  return wineAppAuthedClient.request({
    method: 'POST',
    url: `/favorite-lists/${soldTo}/`,
    responseType: 'json',
    data: {name, description}
  }).then(response => response.data);
}

function updateFavoriteList(soldTo, favoriteListId, name, description) {
  return wineAppAuthedClient.request({
    method: 'PUT',
    url: `/favorite-lists/${soldTo}/${favoriteListId}/`,
    responseType: 'json',
    data: {name, description}
  }).then(response => response.data);
}

function deleteFavoriteList(soldTo, favoriteListId) {
  return wineAppAuthedClient.request({
    method: 'DELETE',
    url: `/favorite-lists/${soldTo}/${favoriteListId}/`,
  }).then(response => response.data);
}

function addItem(soldTo, favoriteListId, wineId) {
  return wineAppAuthedClient.request({
    method: 'POST',
    url: `/favorite-lists/${soldTo}/${favoriteListId}/items`,
    responseType: 'json',
    data: {wineId}
  }).then(response => response.data);
}

function removeItem(soldTo, favoriteListId, wineId) {
  return wineAppAuthedClient.request({
    method: 'DELETE',
    url: `/favorite-lists/${soldTo}/${favoriteListId}/items`,
    params: {wine: wineId},
  }).then(response => response.data);
}

function setMembership(soldTo, wineId, favoriteListIds) {
  return wineAppAuthedClient.request({
    method: 'PUT',
    url: `/favorite-lists/${soldTo}/wines/${wineId}/lists`,
    responseType: 'json',
    data: {favoriteListIds}
  }).then(response => response.data);
}

function removeFromAllLists(soldTo, wineId) {
  return wineAppAuthedClient.request({
    method: 'DELETE',
    url: `/favorite-lists/${soldTo}/wines/${wineId}`,
    responseType: 'json',
  }).then(response => response.data);
}

export const favoriteListsApi = {
  getFavoriteLists,
  getFavoriteList,
  createFavoriteList,
  updateFavoriteList,
  deleteFavoriteList,
  addItem,
  removeItem,
  setMembership,
  removeFromAllLists,
};
